import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
//import { UserService } from '../_services/user.service';
import { AppSettings } from '../_models/settings.models'
import { SeguridadService } from '../_services/seguridad.service'

import { AutentificacionService } from '../_services/autentificacion.service'
import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
   router;


   constructor(
                router: Router, 
                private seguridad: SeguridadService,
                private autentificacion: AutentificacionService,
                private globalEventsManager: GlobalEventsManager) {
       this.router = router;
   }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      
       const body = request.body;
 
       if (body !== null && body.hasOwnProperty('action')) {
           body.api_keytoken =  AppSettings.API_KEYTOKEN;
           if (localStorage.currentUserToken) {
               body.tokenid = localStorage.currentUserToken;
           }
           request = request.clone({
               setHeaders: {
                   'Content-Type': 'application/json'
               },
               body: body,

           });
       } else {
           request = request.clone({
               setHeaders: {
                   'Content-Type': 'application/json',
                   'tokenid': localStorage.currentUserToken,
                   'api_keytoken':  AppSettings.API_KEYTOKEN

               },
           });
       }
       
       return next.handle(request).pipe(
        tap(
            response => {

            },
            err => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 403 || err.status === 401) {
                        if ('errormsg' in err.error) {
                           // this.userService.setEndSessionMessage(err.error.errormsg);
                        } else {
                          //  this.userService.setEndSessionMessage(err.error.error);
                        }
                     //   this.userService.removeLocalStorageSession();
                        
                        this.router.navigate(['/login']);
                    }
                }
            }
        )
    );






}
  

}


// WEBPACK FOOTER //
// ./src/app/_interceptors/request.interceptor.ts